export class DateUtil {

  private static monthList: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct.', 'Nov', 'Dec']

  public static formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const mins = date.getMinutes();

    let monthStr = this.monthList[month];

    let dayStr = ''+day;
    if (day < 10) dayStr = '0' + dayStr;

    let hourStr = ''+hours;
    if (hours < 10) hourStr = '0' + hourStr;

    let minsStr = ''+mins;
    if (mins < 10) minsStr = '0' + minsStr;

    return dayStr + ' ' + monthStr + ' ' + year + ' ' + hourStr + ':' + minsStr;
  }
}
